import { render, staticRenderFns } from "./NumberKeyboard.vue?vue&type=template&id=1f8574ca&"
import script from "./NumberKeyboard.vue?vue&type=script&lang=js&"
export * from "./NumberKeyboard.vue?vue&type=script&lang=js&"
import style0 from "./NumberKeyboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports